
import React, {FC, useEffect, useRef} from 'react';
import {useToggle} from 'hooks/useToggle';
import SimpleBar from 'simplebar';
import {Summary} from 'templates/reports/query';

import Header from './Header';
import Row from './Row';

import 'simplebar/dist/simplebar.css';
import * as styles from './styles.module.scss';

const toggleCnt = 3;

type ResultsListProps = {
	data: Summary[]
}

const ResultsList: FC<ResultsListProps> = ({data}) => {
	const {open, toggle} = useToggle(false);
	const inner = useRef<HTMLDivElement>(null);

	const show = open ? data : data.slice(0, toggleCnt);
	const prev = (i: number) => (
		i + 1 < data.length ? data[i + 1] : null
	);

	useEffect(() => {
		if (inner.current) {
			new SimpleBar(inner.current, {
				autoHide: false,
				forceVisible: 'x',
			});
		}
	}, [inner.current]);

	return (
		<div className={styles.wrapper}>
			<div className={styles.inner} ref={inner}>
				<table className={styles.table}>
					<Header />
					<tbody>
						{show.map((r, i) => (
							<Row key={i} curr={r} prev={prev(i)} />
						))}
					</tbody>
				</table>
			</div>
			{data.length > toggleCnt ? (
				<div className={styles.toggle}>
					<span onClick={toggle}>
						Show {open ? 'less' : 'more'}
					</span>
				</div>
			) : (
				// Add a little space to make it look
				// right even without a show link
				<div className={styles.togglePadding} />
			)}
		</div>
	);
};

export default ResultsList;
